export default class RolesListCtrl {

  constructor ($scope, $timeout, $mdDialog, $cookies, WorkPlanSrv, WorkPlanModalSrv, $stateParams, WorkPlanIndicatorSrv, GlobalConfig, Requests, $sessionStorage) {
    var rolesListVm = this
    const currentUser = JSON.parse($cookies.get('currentUser'))
    rolesListVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList
    rolesListVm.$sessionStorage = $sessionStorage

    rolesListVm.mainLabel = 'Roles'
    rolesListVm.gradRoleClass = 'grad-1'
    rolesListVm.carouselResponsiveBreakpoints = [
      {
        breakpoint: 1360,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 1366,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 1920,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 3000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }
    ]


	// VARIABLES
    rolesListVm.viewLoaded = false
    rolesListVm.active = GlobalConfig.generals.active
    rolesListVm.notActive = GlobalConfig.generals.notActive
    rolesListVm.filterSearchResult = GlobalConfig.appTexts.filterResult.unSatisfactory
    rolesListVm.imgEmpty = require('../../../../../../assets/images/empty_state_illustration.svg')
    rolesListVm.planningFinish = true
    $scope.classPlanning = ''
    rolesListVm.inReview = 0
    rolesListVm.feedback = 0

  // METHODS
    rolesListVm.roles = []
    rolesListVm.updateView = updateView
    rolesListVm.confirmDeleteRole = confirmDeleteRole
    rolesListVm.getGeneralsWorkplan = getGeneralsWorkplan
    rolesListVm.bitacora = bitacora


    activate()

    function activate () {
      let post = {
        workplanId: currentUser.workplanId,
        teacherId: currentUser.teacherId,
      }

      if(rolesListVm.workPlanGeneralList != undefined){
        rolesListVm.status = rolesListVm.workPlanGeneralList.wokplanTeacherStatus[0]
        rolesListVm.stages = rolesListVm.workPlanGeneralList.stages
        rolesListVm.inReview = rolesListVm.status.reviewed
        rolesListVm.feedback = rolesListVm.status.feedbackReviewed
        rolesListVm.workplanTeacherId = rolesListVm.status.workplanTeacherId
        isPlanning(rolesListVm.status, rolesListVm.stages)

        if(rolesListVm.feedback && !rolesListVm.planningFinish){
          getDataRolesListReject(post)
        }else{
          getDataRolesList(post)
        }
      }else{
        getGeneralsWorkplan(post).then((promise) => {
          if(rolesListVm.feedback && !rolesListVm.planningFinish){
            getDataRolesListReject(post)
          }else{
            getDataRolesList(post)
          }
        })
      }
    }

    function getDataRolesList(post){
      WorkPlanSrv.getDataRolesList.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            loadData(dataReturn.workplanlistdate)
          }
        },
        data => {
          console.log(workplanlistdate)
        }
      )
    }

    function getDataRolesListReject(post){
      WorkPlanSrv.getDataRolesListReject.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            loadData(dataReturn.workplanlistdate)
          }
        },
        data => {
          console.log(workplanlistdate)
        }
      )
    }

  function loadData (data) {
      rolesListVm.roles = data
      /*for (var i = rolesListVm.roles.length - 1; i >= 0; i--) {
        rolesListVm.roles[i].startDate= moment(rolesListVm.roles[i].startDate).format('YYYY-MM-DD')
        rolesListVm.roles[i].endDate= moment(rolesListVm.roles[i].endDate).format('YYYY-MM-DD')
      }*/
      updateView()
    }

    function updateView () {
      rolesListVm.viewLoaded = false
      $timeout(() => {
        rolesListVm.viewLoaded = true
      }, 1)
    }

    function confirmDeleteRole (itemRole) {     
      let rolArray = rolesListVm.roles.indexOf(itemRole) 
      let roleName = itemRole.roleName
      let roleId = itemRole.roleId
      let workplanTeacherActivityId = itemRole.workplanTeacherActivityId
      //console.log(itemRole)
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanIndicatorSrv) {
          let ctrlModalVM = this
          ctrlModalVM.rolArrayCode = rolArray
          ctrlModalVM.roleName = roleName
          ctrlModalVM.roleId = roleId
          ctrlModalVM.workplanTeacherActivityId = workplanTeacherActivityId
          ctrlModalVM.close = function () {
            $mdDialog.hide()
          }
          ctrlModalVM.deleteRole = function () {
            WorkPlanSrv.disableActivity.delete({workplanTeacherActivityId: ctrlModalVM.workplanTeacherActivityId})
            .$promise.then(function (dataReturn) {
              if (dataReturn.status) {
                showSuccessDialog(ctrlModalVM.roleName)
                updateView()
                WorkPlanIndicatorSrv.setVariable(true)
                rolesListVm.roles.splice(ctrlModalVM.rolArrayCode, 1)
                $mdDialog.hide()
              } else {
                console.log('Comunications problem with the server')
              }
            }, function (data) {

            })
          }
        }],
        controllerAs: 'ctrlModalVM',
        template: require('./deleteRoleModal.html'),
        clickOutsideToClose: false
      })
    }

    function showSuccessDialog(name){
      let texts = GlobalConfig.appTexts
      let header = {
        createOrEdit     : texts.deleteDialog,
        textCreateOrEdit : texts.deleted,
        itemName         : name,
        nameModal        : texts.modalTypeName.deleted,
        modalType        : texts.modalTypeId.default
      }
      WorkPlanModalSrv.setVariableSuccessDialog(header)
      WorkPlanModalSrv.successDialog(header).then((promise) => { })
    }

    function getGeneralsWorkplan(post){
      return WorkPlanSrv.getElementsRightBar.getList({teacherId: post.teacherId}).$promise.then(function(dataReturn) {
        if(dataReturn.status){
          rolesListVm.$sessionStorage.workPlanGeneralList = dataReturn.data
          rolesListVm.status = dataReturn.data.wokplanTeacherStatus[0]
          rolesListVm.stages = dataReturn.data.stages
          rolesListVm.inReview = rolesListVm.status.reviewed
          rolesListVm.feedback = rolesListVm.status.feedbackReviewed
          rolesListVm.workplanTeacherId = rolesListVm.status.workplanTeacherId
          isPlanning(rolesListVm.status, rolesListVm.stages)
        }else{
          console.log("Comunications problem with the server")
        }
      },function(data) {
           console.log(data);
      }) 
    }

    function isPlanning(status, stages){
      rolesListVm.currentDate = moment(new Date()).format("DD/MM/YYYY")
      for (var i = stages.length - 1; i >= 0; i--) {
        if(stages[i].stageId == GlobalConfig.workplanIdStages.review){
          rolesListVm.startDateStage = stages[i].startDate
        }
      }

      if(status.workplanActive){
        if (status.planningFinish == rolesListVm.active){        
          rolesListVm.planningFinish = true
          if (rolesListVm.startDateReview < rolesListVm.currentDate || status.reviewedFinish == rolesListVm.active){
            rolesListVm.planningFinish = true
          }else if (status.reviewedReject == rolesListVm.active){
            rolesListVm.planningFinish = false
          }
        } else {
            rolesListVm.planningFinish = false
        }
      }else{
        rolesListVm.planningFinish = true
      }

      $scope.classPlanning = (rolesListVm.planningFinish ? "disabled" : " ")
    }

    function bitacora (ev) {
      let entries = {}

      entries.params = {
        activityTypeId: GlobalConfig.activityTypeId.roles,
        workplanTeacherId: rolesListVm.workplanTeacherId
      }
      entries.title = 'Roles'
      // Entries(this.entries);
      entries.data = undefined
      $mdDialog.show({
        controller: 'bitacoraModalCtrl',
        controllerAs: 'bit',
        template: require('../../../../strategicTracking/detailsByTeacher/bitacoraModal/bitacoraModal.html'),
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {data: entries},
        clickOutsideToClose: true,
        fullscreen: true
      })
    }

  }
}

RolesListCtrl.$inject = ['$scope', '$timeout', '$mdDialog', '$cookies', 'WorkPlanSrv', 'WorkPlanModalSrv', '$stateParams', 'WorkPlanIndicatorSrv', 'GlobalConfig', 'Requests', '$sessionStorage']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/academicManagement/roles/list/rolesListCtrl.js